import {deviceFleetConstants} from '_constants'
import {deviceService} from '_services'

export const deviceFleetActions = {
  updateSerial,
  updateAll,
  updateErrorCodes,
  updateCommissionedDeviceList,
  updateDeviceStateV2,
  fetchDeviceStateV2,
};


function updateAll(all_devices) {
  return {type: deviceFleetConstants.UPDATE_ALL_DEVICES, all_devices}
}

function updateCommissionedDeviceList(all_commissioned_devices) {
  return {type: deviceFleetConstants.UPDATE_ALL_COMMISSIONED_DEVICES, all_commissioned_devices}
}

function updateSerial(device_serial) {
  localStorage.setItem("selected_device_serial", device_serial)
  return {type: deviceFleetConstants.UPDATE_DEVICE_SERIAL, device_serial}
}

function updateErrorCodes(error_codes) {
  return {type: deviceFleetConstants.UPDATE_ERROR_CODES, error_codes}
}


function updateDeviceStateV2(device_state_v2) {
  return {type: deviceFleetConstants.UPDATE_DEVICE_STATE_V2, device_state_v2}
}


/**
 * Fetch device state(s) into the store.
 * @param {string | Array<string>} [serial_number] - Optional serial(s) to refresh; omit to refresh all.
 */
function fetchDeviceStateV2(serial_number) {
  return function (dispatch) {
    return deviceService.getBulkStateV2(serial_number, function (normalized) {
      dispatch(updateDeviceStateV2(normalized))
    }, function (error) {
      // Let the existing error handler deal with it, or dispatch a failure action
    })
  }
}
